"use client";

import { useEffect, useId, useState } from "react";
import { Menu, X } from "lucide-react";

import { navigation } from "@/config/navigation";
import { cn } from "@/lib/utils";

export function MobileMenu() {
  const [open, setOpen] = useState(false);
  const panelId = useId();

  useEffect(() => {
    if (!open) return;

    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") setOpen(false);
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [open]);

  return (
    <div className="md:hidden">
      <button
        type="button"
        aria-expanded={open}
        aria-controls={panelId}
        aria-label={open ? "Zavřít nabídku" : "Otevřít nabídku"}
        onClick={() => setOpen((value) => !value)}
        className="inline-flex size-11 items-center justify-center text-paper"
      >
        {open ? (
          <X aria-hidden="true" strokeWidth={1.5} className="size-5" />
        ) : (
          <Menu aria-hidden="true" strokeWidth={1.5} className="size-5" />
        )}
      </button>

      <div
        id={panelId}
        hidden={!open}
        className={cn(
          "absolute inset-x-0 top-full border-t border-hairline-dark bg-ink",
          open ? "block" : "hidden",
        )}
      >
        <nav aria-label="Mobilní navigace" className="px-5 py-4">
          <ul className="flex flex-col">
            {navigation.map((item) => (
              <li key={item.href} className="border-b border-hairline-dark">
                <a
                  href={item.href}
                  onClick={() => setOpen(false)}
                  className="flex min-h-11 items-center py-3 font-sans text-base text-paper"
                >
                  {item.label}
                </a>
              </li>
            ))}
            <li className="pt-4">
              <a
                href="#kontakt"
                onClick={() => setOpen(false)}
                className="flex min-h-11 w-full items-center justify-center bg-paper px-6 py-3 font-mono text-[0.8125rem] uppercase tracking-[0.12em] text-ink"
              >
                Konzultace zdarma
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
}
